import { createContext } from "react";

const modalContext = createContext({
  open: false,
  setModalOpen: (open) => {},
  component: null,
  setModalComponent: (component) => {}
});

export default modalContext;
